import {Customer} from "../models/Customer";

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER'

type LoginAction = {
    type: typeof LOGIN;
    payload: {
        customer: Customer;
    };
}

type RegisterAction = {
    type: typeof REGISTER;
    payload: {
        customer: Customer
    };
}

type LogoutAction = {
    type: typeof LOGOUT
}

export type AppActionTypes = LoginAction | LogoutAction | RegisterAction